// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage } from "react-intl";

export const BadgeGameLens = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeGameLens"
        description="Badge game lens."
        defaultMessage="Game"
    />
);
BadgeGameLens.displayName = "BadgeGameLens";

export const BadgeTitleLensCreatorPayoutEligible = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeTitleLensCreatorPayoutEligible"
        description="Badge title lens creator payout eligible."
        defaultMessage="Top Performer Payouts Eligible"
    />
);
BadgeTitleLensCreatorPayoutEligible.displayName = "BadgeTitleLensCreatorPayoutEligible";

export const BadgeContentLensCreatorPayoutEligible = (props: { note: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeContentLensCreatorPayoutEligible"
        description="Badge content lens creator payout eligible."
        defaultMessage="Your Lens is enrolled in the Top Performer Payouts.&nbsp;{note}"
        values={props}
    />
);
BadgeContentLensCreatorPayoutEligible.displayName = "BadgeContentLensCreatorPayoutEligible";

export const BadgeTitleLensCreatorPayoutIneligible = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeTitleLensCreatorPayoutIneligible"
        description="Badge title lens creator payout ineligible."
        defaultMessage="Top Performer Payouts Ineligible"
    />
);
BadgeTitleLensCreatorPayoutIneligible.displayName = "BadgeTitleLensCreatorPayoutIneligible";

export const BadgeContentLensCreatorPayoutIneligible = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeContentLensCreatorPayoutIneligible"
        description="Badge content lens creator payout ineligible."
        defaultMessage="This Lens is not eligible for Top Performer Payouts."
    />
);
BadgeContentLensCreatorPayoutIneligible.displayName = "BadgeContentLensCreatorPayoutIneligible";

export const BadgeTitleLensCreatorPayoutPending = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeTitleLensCreatorPayoutPending"
        description="Badge title lens creator payout pending."
        defaultMessage="Top Performer Payouts Pending"
    />
);
BadgeTitleLensCreatorPayoutPending.displayName = "BadgeTitleLensCreatorPayoutPending";

export const BadgeContentLensCreatorPayoutPending = (props: { note: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeContentLensCreatorPayoutPending"
        description="Badge content lens creator payout pending."
        defaultMessage="The Lens is currently under review for eligibility.&nbsp;{note}"
        values={props}
    />
);
BadgeContentLensCreatorPayoutPending.displayName = "BadgeContentLensCreatorPayoutPending";

export const BadgeContentLensCreatorPayoutNote = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeContentLensCreatorPayoutNote"
        description="Badge content lens creator payout note."
        defaultMessage="(Note: enrollment does not guarantee rewards)"
    />
);
BadgeContentLensCreatorPayoutNote.displayName = "BadgeContentLensCreatorPayoutNote";

export const BadgeTitleLensCreatorPayoutTOSActionRequired = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeTitleLensCreatorPayoutTOSActionRequired"
        description="Badge title lens creator payout tos action required."
        defaultMessage="Action Required"
    />
);
BadgeTitleLensCreatorPayoutTOSActionRequired.displayName = "BadgeTitleLensCreatorPayoutTOSActionRequired";

export const BadgeContentLensCreatorPayoutTOS = (props: { tosLink: ReactNode; note: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeContentLensCreatorPayoutTOS"
        description="Badge content lens creator payout to s."
        defaultMessage="We've updated the {tosLink}. In order to continue participating in the monetization programs, you will need to accept the updated Terms.&nbsp;{note}"
        values={props}
    />
);
BadgeContentLensCreatorPayoutTOS.displayName = "BadgeContentLensCreatorPayoutTOS";

export const BadgeContentLensCreatorPayoutTOSCTA = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeContentLensCreatorPayoutTOSCTA"
        description="Badge content lens creator payout tosct a."
        defaultMessage="Monetization Program Terms"
    />
);
BadgeContentLensCreatorPayoutTOSCTA.displayName = "BadgeContentLensCreatorPayoutTOSCTA";

export const BadgeTitleExclusiveLensExclusive = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeTitleExclusiveLensExclusive"
        description="Badge title exclusive lens exclusive."
        defaultMessage="Lens+ Payouts"
    />
);
BadgeTitleExclusiveLensExclusive.displayName = "BadgeTitleExclusiveLensExclusive";

export const BadgeContentExclusiveLensExclusive = (props: { note: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeContentExclusiveLensExclusive"
        description="Badge content exclusive lens exclusive."
        defaultMessage="Your Lens is exclusive to Lens+ and Snapchat Premium users.&nbsp;{note}"
        values={props}
    />
);
BadgeContentExclusiveLensExclusive.displayName = "BadgeContentExclusiveLensExclusive";

export const BadgeTitleExclusiveLensEligible = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeTitleExclusiveLensEligible"
        description="Badge title exclusive lens eligible."
        defaultMessage="Lens+ Payouts Pending"
    />
);
BadgeTitleExclusiveLensEligible.displayName = "BadgeTitleExclusiveLensEligible";

export const BadgeContentExclusiveLensEligible = (props: { note: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeContentExclusiveLensEligible"
        description="Badge content exclusive lens eligible."
        defaultMessage="Your Lens is pending approval for Lens+ Payouts.&nbsp;{note}"
        values={props}
    />
);
BadgeContentExclusiveLensEligible.displayName = "BadgeContentExclusiveLensEligible";

export const BadgeTitleExclusiveLensIneligible = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeTitleExclusiveLensIneligible"
        description="Badge title exclusive lens ineligible."
        defaultMessage="Lens+ Payouts Ineligible"
    />
);
BadgeTitleExclusiveLensIneligible.displayName = "BadgeTitleExclusiveLensIneligible";

export const BadgeContentExclusiveLensIneligible = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeContentExclusiveLensIneligible"
        description="Badge content exclusive lens ineligible."
        defaultMessage="This Lens is not eligible for the Lens+ Payouts."
    />
);
BadgeContentExclusiveLensIneligible.displayName = "BadgeContentExclusiveLensIneligible";

export const BadgeTitleExclusiveLensRemoved = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeTitleExclusiveLensRemoved"
        description="Badge title exclusive lens removed."
        defaultMessage="Removed from Lens+ Program"
    />
);
BadgeTitleExclusiveLensRemoved.displayName = "BadgeTitleExclusiveLensRemoved";

export const BadgeContentExclusiveLensRemoved = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeContentExclusiveLensRemoved"
        description="Badge content exclusive lens removed."
        defaultMessage="This Lens did not meet the minimum threshold and has been removed from the Lens+ Program. It is no longer eligible for Lens+ payouts."
    />
);
BadgeContentExclusiveLensRemoved.displayName = "BadgeContentExclusiveLensRemoved";

export const BadgeTitleBothProgramsActive = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeTitleBothProgramsActive"
        description="Badge title both programs active."
        defaultMessage="Monetization Programs"
    />
);
BadgeTitleBothProgramsActive.displayName = "BadgeTitleBothProgramsActive";

export const BadgeContentBothProgramsActive = (props: { note: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeContentBothProgramsActive"
        description="Badge content both programs active."
        defaultMessage="Your Lens is enrolled in both Top Performer Payouts and Lens+ Payouts.&nbsp;{note}"
        values={props}
    />
);
BadgeContentBothProgramsActive.displayName = "BadgeContentBothProgramsActive";

export const BadgeTitleBothProgramsEligible = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeTitleBothProgramsEligible"
        description="Badge title both programs eligible."
        defaultMessage="Monetization Programs Eligible"
    />
);
BadgeTitleBothProgramsEligible.displayName = "BadgeTitleBothProgramsEligible";

export const BadgeContentBothProgramsEligible = (props: { note: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeContentBothProgramsEligible"
        description="Badge content both programs eligible."
        defaultMessage="Your Lens is eligible for both Top Performer Payouts and Lens+ Payouts.&nbsp;{note}"
        values={props}
    />
);
BadgeContentBothProgramsEligible.displayName = "BadgeContentBothProgramsEligible";

export const BadgeTitleMixedProgramStatus = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeTitleMixedProgramStatus"
        description="Badge title mixed program status."
        defaultMessage="Monetization Programs"
    />
);
BadgeTitleMixedProgramStatus.displayName = "BadgeTitleMixedProgramStatus";

export const BadgeContentMixedProgramStatus = (props: {
    exclusiveStatus: ReactNode;
    rewardsStatus: ReactNode;
    note: ReactNode;
}): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.row.badgeContentMixedProgramStatus"
        description="Badge content mixed program status."
        defaultMessage="Your Lens has different statuses across monetization programs. {exclusiveStatus} {rewardsStatus}&nbsp;{note}"
        values={props}
    />
);
BadgeContentMixedProgramStatus.displayName = "BadgeContentMixedProgramStatus";
